














































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';
import DownloadIcon from 'mdi-vue/Download';
import FilterIcon from 'mdi-vue/Filter';
import { mapState } from 'vuex';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';
import Toggle from '@/components/Toggle.vue';
import Button from '@/components/Button.vue';
import Select from '@/components/Select.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import { AxiosError } from 'axios';
import { api2 } from '@/libs/api';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { DateRange } from '@/components/DatePickerWtoday.vue';
import SingleDatePickerNoTP from '@/components/SingleDatePickerNoTP.vue';
import StagingTable from './StagingTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    FormInput,
    Toggle,
    Button,
    Select,
    SearchIcon,
    ExportIcon,
    SearchField,
    SearchRow,
    StagingTable,
    DownloadIcon,
    FilterIcon,
    SingleDatePickerNoTP,
  },
  computed: mapState(['user']),
  props: {

  },
})
export default class Staging extends Vue {
  title = 'Staging Alterra';
  titleDescription = 'Reconciliation Staging Alterra';
  templateCode = '';

  selectList: any = {};
  selectParams: any = {};

  $refs!: {
    report: StagingTable;
  }

  searchOpen = false;

  forms: any = [];

  searchParams: any = {};

  formDefaultValue: any = {};

  dataDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  periodDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  mounted() {
    this.getConf();
  }

  @Watch('$route')
  onRouteChange() {
    this.getConf();
  }

  @Watch('dataDate')
  onInputDataDate = (newValue: any) => {
    if (newValue.startDate && newValue.startDate !== '') {
      this.periodDate.startDate = dayjs(newValue.startDate).toDate().toString();
    }
  }

  async getConf() {
    this.templateCode = this.$route.params.templateCode;
    this.searchOpen = false;
    const { data } = await api2.post(`/recon/stg/conf/${this.templateCode}`, {});
    this.title = data.headers.template_title;
    this.titleDescription = data.headers.template_description;
    this.formDefaultValue = data.formDefaultValue;
    this.setSelectList(data.forms);
    this.forms = data.forms;
    this.emptySearchParams();
    this.setParamsSearchDefault(data.forms);
    // console.log(JSON.stringify(this.searchParams));
    // this.setParamsSearchDefault();
    // this.getTransaction(0);
    this.search();
  }

  setParamsSearchDefault(formsInput: any) {
    const tmpForms = formsInput.filter((form: any) => form.form_default_val !== '');
    tmpForms.forEach((row: any) => {
      if (row.column_db === 'data_date') {
        this.dataDate.startDate = dayjs(this.formDefaultValue.data_date, 'DD-MM-YYYY').toDate().toString();
      }
      if (row.column_db === 'period_date') {
        this.periodDate.startDate = dayjs(this.formDefaultValue.period_date, 'DD-MM-YYYY').toDate().toString();
      }
      if (row.column_db !== 'data_date' && row.column_db !== 'period_date' && row.form_type === 'select') {
        this.searchParams[row.column_db] = row.form_default_val;
      }
    });
  }

  async setSelectList(formsInput: any) {
    const tmpForms = formsInput.filter((form: any) => form.form_type === 'select');
    tmpForms.forEach((row: any) => {
      this.searchParams[row.column_db] = '';
      this.selectList[row.column_db] = [];

      try {
        api2.post(`/recon/stg/param/${this.templateCode}`, {
          column: row.column_db,
        }).then((response) => {
          this.selectList[row.column_db] = response.data;
          this.selectList[row.column_db].unshift({ label: 'All', value: '' });

          const tmpFormsDefaultVal = formsInput.filter((form: any) => form.form_type === 'select'
            && form.form_default_val !== '' && form.column_db === row.column_db);
          if (tmpFormsDefaultVal && tmpFormsDefaultVal.length > 0) {
            const tmpLabel = response.data.filter((res: any) => res.value === row.form_default_val)[0].label;
            this.selectParams[row.column_db] = { value: row.form_default_val, label: tmpLabel };
          }
        });
      } catch (err) {
        console.log(err);
      }
    });
  }

  async getTransaction(pageParams: any) {
    await this.$refs.report.getTransaction(this.templateCode, this.forms, this.searchParams, pageParams);
  }

  search() {
    const tmpForms = this.forms.filter((form: any) => form.column_db === 'data_date'
      || form.column_db === 'period_date');
    tmpForms.forEach((form: any) => {
      if (form.column_db === 'data_date') {
        const tmpDate = this.dataDate.startDate ? dayjs(this.dataDate.startDate).format(form.form_date_format) : '';
        this.searchParams.data_date = tmpDate;
      }
      if (form.column_db === 'period_date') {
        const tmpDate = this.periodDate.startDate ? dayjs(this.periodDate.startDate).format(form.form_date_format) : '';
        this.searchParams.period_date = tmpDate;
      }
    });

    const tmpSelectForm = this.forms.filter((form: any) => form.form_type === 'select');
    tmpSelectForm.forEach((form: any) => {
      if (this.selectParams[form.column_db]) {
        this.searchParams[form.column_db] = this.selectParams[form.column_db].value;
      }
    });

    this.getTransaction(1);
  }

  async exportData() {
    try {
      api2.post(`/recon/stg/export/${this.templateCode}`, {
        searchParams: this.searchParams,
      }, { responseType: 'blob' }).then((response) => {
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${this.title}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        showToast(ToastType.SUCCESS, 'Export Report', 'Export finished');
      });
    } catch (err) {
      console.log(err);
      showToast(ToastType.FAILED, `Error [${(err as AxiosError).response?.status}]`, 'Failed to export Report');
    }
  }

  emptySearchParams() {
    this.searchParams = {};
    this.selectParams = {};
  }

  cancel() {
    this.emptySearchParams();
    this.toggleSearchOpen();
    this.getTransaction(1);
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }
}
